import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import RoadiesIndex from './pages/roadies/RoadiesIndex';
import RoadiesStage1 from './pages/roadies/RoadiesStage1';
import RoadiesStage2 from './pages/roadies/RoadiesStage2';
import RoadiesStage3 from './pages/roadies/RoadiesStage3';
import RoadiesStage4 from './pages/roadies/RoadiesStage4';
import RoadiesStage5 from './pages/roadies/RoadiesStage5';
import RoadiesStage6 from './pages/roadies/RoadiesStage6';
import RoadiesStage7 from './pages/roadies/RoadiesStage7';
import RoadiesStage8 from './pages/roadies/RoadiesStage8';
import RoadiesThankyou from './pages/roadies/RoadiesThankyou';
import RoadiesLeaderboard from './pages/roadies/RoadiesLeaderboard';

// Redirect to the landing page but keep ?otp=…&role=… / ?demo=… so a refresh can log in again.
function ToIndex() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/', search }} replace />;
}

// Same flow as the PHP game: index (intro video + BEGIN PLAY) -> stage1..stage8 -> thankyou (-> leaderboard)
function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route index element={<RoadiesIndex />} />
        <Route path="/login" element={<ToIndex />} />
        <Route path="/story" element={<ToIndex />} />
        <Route path="/stage1" element={<RoadiesStage1 />} />
        <Route path="/stage2" element={<RoadiesStage2 />} />
        <Route path="/stage3" element={<RoadiesStage3 />} />
        <Route path="/stage4" element={<RoadiesStage4 />} />
        <Route path="/stage5" element={<RoadiesStage5 />} />
        <Route path="/stage6" element={<RoadiesStage6 />} />
        <Route path="/stage7" element={<RoadiesStage7 />} />
        <Route path="/stage8" element={<RoadiesStage8 />} />
        <Route path="/thankyou" element={<RoadiesThankyou />} />
        <Route path="/leaderboard" element={<RoadiesLeaderboard />} />
        <Route path="*" element={<ToIndex />} />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
